import React from 'react';

const CloseIcon = ({ className = '', size = '18px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24" // Aquí cambias el viewBox
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-black ${className}`}
  >
    <path d="M6 18L18 6M6 6l12 12" stroke="black" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default CloseIcon;
